function getCountryFromURL() {
  const url = window.location.href;

  const urlParams = new URLSearchParams(window.location.search) || "";

//   const country = urlParams.get("country") || "AU";
//   return country.toUpperCase();
// }
  if (url != "") {
    // if (url.includes("staging")) {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   return urlParams.get("country") ? urlParams.get("country") : "AU";
    // } else if (url.includes("au")) {
    //   return "AU";
    // } else {
    //   return "NZ";
    // }
    if (url.includes("nz") || urlParams.get("country") == "nz" || url.includes("NZ") || urlParams.get("country") == "NZ") {
      return "NZ";
    } else {
      return "AU";
    }
  }
}

export default getCountryFromURL;
